import Immutable from 'seamless-immutable';
import { normalize } from 'normalizr';
import shortid from 'shortid';
import pubnub from '../../pubnub';
import schema from '../../schema';
import ActionTypes from './actionTypes';

const Actions = {
  creators: {
    receivedMessageUpdate: data => ({
      data,
      type: ActionTypes.RECEIVED_MESSAGE_UPDATE,
    }),
    receivedMessage: data => ({
      data,
      type: ActionTypes.RECEIVED_MESSAGE,
    }),
    receivedMessages: data => ({
      data,
      type: ActionTypes.RECEIVED_MESSAGES,
    }),
    sendNewMessage: data => ({
      data,
      type: ActionTypes.SEND_NEW_MESSAGE,
    }),
    presenceUpdate: data => ({
      data,
      type: ActionTypes.PRESENCE_UPDATE,
    }),
  },
  thunks: {
    listen: () => dispatch => {
      console.log('We are listening!');
      pubnub.addListener({
        message: m => {
          console.log(m);
          const message = Object.assign(
            { createdAt: new Date(Number(m.timetoken) / 1000).getTime() },
            m.message,
            { channelId: m.channel },
          );
          dispatch(
            Actions.creators.receivedMessage(
              normalize(message, schema.MESSAGE),
            ),
          );
        },
        presence: p => {
          // handle presence
          // const action = p.action; // Can be join, leave, state-change or timeout
          // const channelName = p.channel; // The channel for which the message belongs
          // const channelGroup = p.subscription; //  The channel group or wildcard subscription match (if exists)
          // const presenceEventTime = p.timestamp; // Presence event timetoken
          // const status = p.status; // 200
          // const message = p.message; // OK
          // const service = p.service; // service
          // const uuids = p.uuids; // UUIDs of users who are connected with the channel with their state
          // const occupancy = p.occupancy; // No. of users connected with the channel
          const { occupancy, channel } = p;
          const data = {
            occupancy,
            name: channel,
          };
          dispatch(Actions.creators.presenceUpdate(data));
        },
        status: s => {
          // handle status
          // const category = s.category; // PNConnectedCategory
          // const operation = s.operation; // PNSubscribeOperation
          // const affectedChannels = s.affectedChannels; // The channels affected in the operation, of type array.
          // const subscribedChannels = s.subscribedChannels; // All the current subscribed channels, of type array.
          // const affectedChannelGroups = s.affectedChannelGroups; // The channel groups affected in the operation, of type array.
          // const lastTimetoken = s.lastTimetoken; // The last timetoken used in the subscribe request, of type long.
          // const currentTimetoken = s.currentTimetoken; // The current timetoken fetched in the subscribe response, which is going to be used in the next request, of type long.
          // console.log('Listening to status in channel: ', s);
        },
      });
    },
    sendMessageToChannel: (data, channel) => dispatch => {
      const messageId = shortid.generate();
      const channelId = channel;
      const sentAt = new Date().getTime();
      const message = Object.assign({ messageId, sentAt, channelId }, data);
      dispatch(
        Actions.creators.sendNewMessage(normalize(message, schema.MESSAGE)),
      );
      pubnub.publish({
        message,
        channel,
      });
    },
    historyForChannel: channel => dispatch => {
      pubnub.history(
        {
          channel,
          reverse: true, // Setting to true will traverse the time line in reverse starting with the oldest message first.
          count: 100, // how many items to fetch
          // stringifiedTimeToken: true, // false is the default
          // start: '123123123123', // start time token to fetch
          // end: '123123123133', // end timetoken to fetch
        },
        (status, response) => {
          // handle status, response
          // console.log('History status: ', status);
          // console.log(response.messages);
          const results = response.messages.map(result => {
            const message = Object.assign(
              {
                createdAt: new Date(Number(result.timetoken) / 1000).getTime(),
              },
              result.entry,
            );
            return message;
          });
          const messages = normalize(results, schema.MESSAGES);
          dispatch(Actions.creators.receivedMessages(messages));
        },
      );
      pubnub.hereNow(
        {
          channels: [channel],
          includeUUIDs: true,
          includeState: true,
        },
        (status, response) => {
          // handle status, response
          if (response.channels[channel]) {
            const { occupancy } = response.channels[channel];
            const data = {
              occupancy,
              name: channel,
            };
            dispatch(Actions.creators.presenceUpdate(data));
          }
        },
      );
    },
  },
};

export { Actions };

const defaultState = Immutable({});

export default (state = defaultState, action) => {
  if (action.type === ActionTypes.SEND_NEW_MESSAGE) {
    return state.merge(action.data.entities.messages);
  } else if (action.type === ActionTypes.RECEIVED_MESSAGE) {
    if (action.data.entities.messages) {
      return state.merge(action.data.entities.messages);
    }
  } else if (action.type === ActionTypes.UNSUBSCRIBED_CHANNELS) {
    return defaultState;
  } else if (action.type === ActionTypes.RECEIVED_MESSAGES) {
    if (action.data.entities.messages) {
      return state.merge(action.data.entities.messages);
    }
  }
  return state;
};



// WEBPACK FOOTER //
// ./src/ducks/chat/messages.js